import { makeStyles } from "@material-ui/core/styles";
import { AssetGroupsGenericTypes } from "../../../../../constants/assetGroupsGenericTypes";

export const responseTypes = (resources) => {
	return [
		{ value: 10, name: resources["TypeColorGreenAmberRed"] },
		{ value: 11, name: resources["TypeColorGreenRed"] },
		{ value: 12, name: resources["TypeColorGreen"] },
		{ value: 13, name: resources["TypeYesNo"] },
		{ value: 20, name: resources["TypeExterior"] },
		{ value: 50, name: resources["TypeDate"] },
		{ value: 60, name: resources["TypeMileage"] },
		{ value: 70, name: resources["TypeCountNumber"] },
		{ value: 80, name: resources["TypeText"] },
	];
};

export const selectStyles = makeStyles(() => ({
	root: {
		padding: "3px 0 0 7px !important",
	},
}));

export const templateTypes = [{ key: 2, name: "Service" }];

export const objectTypes = (resources) => {
	return [
		{
			name: resources["Car"],
			key: AssetGroupsGenericTypes.Car,
		},
		{
			name: resources["Bike"],
			key: AssetGroupsGenericTypes.Bike,
		},
		{
			name: resources["MotorBike"],
			key: AssetGroupsGenericTypes.Motorbike,
		},
	];
};

export const languages = [
	{ code: "nl", label: "NL" },
	{ code: "fr", label: "FR" },
	{ code: "de", label: "DE" },
	{ code: "en", label: "EN" },
	{ code: "cs", label: "CS" },
];

export const syncTranslationKeys = ["description", "shortDescription"];
